// Material
import { User } from '@weblite/ts-action/user'
import { Stack, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { UserAvatar } from '$common/avatar'
// Helpers
import { getUserDisplayName } from '$logic/users'
import { useClientUser } from '$logic/client-user/react-hook'
import { toHumanReadablePhone } from '$func/phone'
import { AvatarSize } from '$common/avatar/avatar-base/types.ts'

const Root = styled(Stack)`
  margin-bottom: 8px;
  margin-right: 15px;
`
const StyledStack = styled(Stack)`
  margin-right: 16px;
`

export function MyAccountProfileInfoHeader() {
  const user = useClientUser()
  return (
    <Root direction="row">
      <UserAvatar userId={user?.id} size={AvatarSize._2XL} openImageViewer />
      <StyledStack justifyContent="center">
        <Typography variant="subtitle1">
          {getUserDisplayName(user as User)}
        </Typography>
        <Typography variant="body2" color="gray" dir="ltr">
          {toHumanReadablePhone(user?.phone)}
        </Typography>
      </StyledStack>
    </Root>
  )
}
